module.exports = __webpack_public_path__ + "static/media/display-tray-interior.5b8ec8b2.png";